import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { TranslateService } from '@ngx-translate/core'
import { KcDataService } from '../../../kc-data.service'
import { KcConsentsViewData } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-revolution-gdpr',
  templateUrl: './revolution-gdpr.component.html'
})
export class RevolutionKcGdprComponent implements OnInit {
  dataProtectionLinks = {
    de: null,
    it: null,
    fr: null
  }

  @ViewChild('consentsForm', { static: false })
  private readonly formRef: ElementRef

  public form = new FormGroup({})

  public viewData: KcConsentsViewData

  public submitting: boolean

  constructor(
    private readonly kcDataService: KcDataService,
    private readonly translate: TranslateService,
    private readonly transifexTranslationsService: TranslationService,
    public transifexService: TransifexService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.dataProtectionLinks = {
      de: this.remoteConfigService.get('footerLinks.dataProtectionLinks.de'),
      it: this.remoteConfigService.get('footerLinks.dataProtectionLinks.it'),
      fr: this.remoteConfigService.get('footerLinks.dataProtectionLinks.fr')
    }
  }

  ngOnInit(): void {
    this.viewData = this.kcDataService.getViewData() as KcConsentsViewData
  }

  submit(): void {
    this.submitting = true
    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  getTranslationGdpr(): string {
    const lang = this.translate.currentLang?.toLowerCase() ?? 'de'
    const consentLink =
      '<a class="text-mat-ef-revolution-secondary-500" target="_blank" href="' +
      String(this.dataProtectionLinks[lang]) +
      '">' +
      String(this.dataProtectionLinks[lang]) +
      '</a>'

    return this.transifexTranslationsService.translate(
      'We respect the privacy of our customers and prospects. We use the personal data for the processing of this contract, for customer care and for marketing purposes and to optimize the quality of service in order to respond to the needs of existing and potential customers. In addition, the data for the above-mentioned purposes can be transmitted to the importer, manufacturer and the partner companies of the Emil Frey Group. We assure that the data will only be used in compliance with data protection regulations. For the rest, we refer to the current version of the data protection declaration on the website: {link}.',
      {
        _key: 'customerPortal.kc.gdpr.text',
        _tags: 'kc-forms, 3.7',
        link: consentLink
      }
    )
  }
}
